import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TourGuide from 'src/components/Banners/TourGuide';
import { getIsHotelOnly } from 'src/store/view/selectors';
import HeaderContainer from '../Header';
import ReviewsDesktop from '../Reviews/ReviewsDesktop';
import HotelInfo from '../HotelInfo';
import SearcherContainer from '../SearcherContainer';
import { COMPONENT_ID } from '../../constants';
import HotelMapContainer from '../HotelMap';
import FacilitiesContainer from '../FacilitiesContainer';
import Container from '../../components/Container';
import Gallery from '../Gallery';
import RatingBadge from '../RatingBadge';
import { getHotelRoulette } from '../../store/selectors/hotel';
import TopMenuContainer from '../TopMenu';
import HintFactory from '../../../../components/Hint/HintFactory';
import OfferExtras from '../../components/TooltipContent/OfferExtras';
import RoomFacilitiesHintFactory from '../HintFactory/RoomFacilitiesHintFactory';
import ExtraItemsContainer from '../ExtraItemsContainer';
import Paper from '../../components/Paper';
import FortunaJumbotronContainer from '../FortunaJumbotronContainer';
import ExperienceContainer from '../ExperienceContainer';
import IncludedServicesHint from './IncludedServicesHint';

import styles from './layout.module.css';

const LayoutDesktop = (props) => {
  const { isRoulette, isHotelOnly } = props;

  return (
    <div className="hotel-desktop">
      <HintFactory events attribute="data-text-hint" />
      <IncludedServicesHint isMobile={false} />
      <HintFactory
        autoPosition
        attribute="data-offer-extras"
        className="react-hint"
        events
        onRenderContent={(target, content) =>
          content && (
            <div className="react-hint__content">
              <OfferExtras extras={JSON.parse(content)} />
            </div>
          )
        }
      />
      <RoomFacilitiesHintFactory />
      <Container white marginBottom={0}>
        <HeaderContainer isHotelOnly={isHotelOnly} />
      </Container>
      <Container id={COMPONENT_ID.GALLERY} fullWidth marginBottom={0}>
        {isRoulette ? (
          <FortunaJumbotronContainer />
        ) : (
          <>
            <RatingBadge />
            <Gallery />
          </>
        )}
      </Container>
      <TopMenuContainer isHotelOnly={isHotelOnly} />
      <Container id={COMPONENT_ID.SEARCHER}>
        <SearcherContainer />
      </Container>
      <Container>{!isHotelOnly && <TourGuide />}</Container>
      <ExperienceContainer
        fullWidth
        id={COMPONENT_ID.EXPERIENCE}
        marginBottom={0}
      />
      <Container id={COMPONENT_ID.HOTEL_FACTS}>
        {isRoulette ? (
          <Paper padding={20}>
            <ExtraItemsContainer />
          </Paper>
        ) : (
          <HotelInfo />
        )}
      </Container>
      <Container id={COMPONENT_ID.MAP}>
        <HotelMapContainer
          className={styles.hotelMapContainer}
          showLayersControl
          showZoomControl
          lazyInit
          height={400}
        />
      </Container>
      {!isRoulette && (
        <>
          <Container id={COMPONENT_ID.FACILITIES}>
            <FacilitiesContainer />
          </Container>
          <Container id={COMPONENT_ID.REVIEWS}>
            <ReviewsDesktop />
          </Container>
        </>
      )}
    </div>
  );
};

LayoutDesktop.propTypes = {
  isRoulette: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isRoulette: getHotelRoulette(state),
  isHotelOnly: getIsHotelOnly(state),
});

export default connect(mapStateToProps)(LayoutDesktop);
